/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js";

export default {
  getCourseStudentFreezing({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get("course-student-freezing", { params: payload })
        .then((response) => {
          commit("SET_COURSE_STUDENT_FREEZING_LIST", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  setCurrentPage({ commit }, data) {
    commit("SET_CURRENT_PAGE", data);
  },

  setPerPage({ commit }, data) {
    commit("SET_PER_PAGE", data);
  },

  addCourseStudentFreezing({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post("course-student-freezing", payload)
        .then((response) => {
          commit("ADD_COURSE_STUDENT_FREEZING", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  updateCourseStudentFreezing({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`course-student-freezing/${id}`, payload)
        .then((response) => {
          commit("UPDATE_COURSE_STUDENT_FREEZING", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  updateStatusFreezing({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`course-student-freezing/${id}/status`, payload)
        .then((response) => {
          commit("UPDATE_STATUS_FREEZING", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
